import { registerModal } from 'features/Modal/ModalRegistry'
import UsersSetRolesModal from './UsersSetRolesModal.container'
import { showModal } from 'features/Modal/Modal.actions'

export const modalType = 'SET_ROLE_MODAL'
registerModal(modalType, UsersSetRolesModal)
export default modalProps =>
  showModal({
    modalType,
    modalProps,
    modalOptions: {},
  })



// WEBPACK FOOTER //
// ./~/@pickle/pickle-shared/src/features/Users/UsersSetRolesModal/UsersSetRolesModal.action.js